import styles from "./TabSelection.module.scss";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * @method TabSelectionHeader
 * @description Handles tab button selection and page routing.
 * @returns {React.ReactElement}
 */
const TabSelection = ({ tabs, activeTab }: any): React.ReactElement => {
  const isAtWorkPro = true;

  // Screen width state
  const [screenWidth, setScreenWidth] = useState<any>();

  useEffect(() => {
    setScreenWidth(window.innerWidth);
  }, [screenWidth]);

  /**
   * Returns curve classes for tab intersection styling.
   */
  const getCurveClasses = (
    index: number,
    activeIndex: number,
    tabsLength: number
  ) => {
    const classes = [];

    if (index > activeIndex && index <= activeIndex + 3) {
      classes.push(styles.after);
    }

    if (index < activeIndex && index >= activeIndex - 2) {
      classes.push(styles.before);
    }

    if (activeIndex === tabsLength - 1 && index === 0) {
      classes.push(styles.before);
    }

    return classes.join(" ");
  };

  return (
    <div className={styles.tabs}>
      {tabs.map((tab: any, index: number) => {
        // Find active tab index
        let activeIndex = tabs.findIndex((t: any) => t?.active);

        if (activeIndex === -1) {
          activeIndex = tabs.findIndex((t: any) =>
            t?.link?.includes(activeTab)
          );
        }

        if (isAtWorkPro) {
          activeIndex = -1;
        } else {
          activeIndex = activeIndex === -1 ? 0 : activeIndex;
        }

        const validActiveTab = tabs[activeIndex]?.link;
        const totalTabs = tabs?.length;

        let zIndex = index === activeIndex ? 99999 : index + 1;

        return (
          <Link
            key={index}
            to={tab.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.tab} ${
              validActiveTab === tab.link ? styles.active : ""
            } ${
              index === totalTabs - 1 && isAtWorkPro
                ? styles.leftBorderInline
                : ""
            }`}
            style={{
              backgroundColor: tab.bgColor,
              ...(tab?.fontColor && { color: tab.fontColor }),
              opacity: validActiveTab === tab.link ? 1 : 0.8,
              zIndex: zIndex,
              backgroundImage: tab.bgImageUrl ? `url(${tab.bgImageUrl})` : "",
              backgroundPosition: "center",
            }}
          >
            {tab?.content ? tab.content : <h1>{tab.label}</h1>}
            <div
              className={`${styles.curve} ${getCurveClasses(
                index,
                activeIndex,
                totalTabs
              )}`}
            />
          </Link>
        );
      })}
    </div>
  );
};

export default TabSelection;
